export default "__VITE_ASSET__2e0a913c__"